import {
  getInvoice,
  // getInvoicePDF,
  getClients,
  getClientById,
  getTransactionReport,
} from "@/api/hc360-invoices.js";
import { consoleSandbox } from "@sentry/utils";

const invoices = {
  namespaced: true,

  state: () => ({
    filters: {
      client_filter_selection: [],
      client_selected: null,
      start_date_filter: null,
      start_date_selected: null,
      end_date_filter: null,
      end_date_selected: null,
      due_date: null,
      bill_to: null,
      email: "",
    },
    local: {
      runningAmount: 0,
      pdf: null,
      invoiceNumber: null,
    },
    data: [],
    getInvoiceData: null,
    getInvoicePDFData: null,
    getClientsData: null,
    getClientByIdData: null,
    getTransactionReportData: null,
    Loading: false,
  }),

  //   getters: {
  //     getState: (state) => {
  //       return state.stateName;
  //     },
  //   },

  actions: {
    getInvoice({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        getInvoice(payload)
          .then((api_data) => {
            state.getInvoiceData = api_data;
            resolve(api_data);
          })
          .catch((err) => {
            reject(err);
            console.log("getInvoice store err", err);
          });
      });
    },

    // getInvoicePDF({ state, commit }, params) {
    //   return new Promise((resolve, reject) => {
    //     getInvoicePDF(params)
    //       .then((api_data) => {
    //         state.getInvoicePDFData = api_data;
    //         resolve(api_data);
    //       })
    //       .catch((err) => {
    //         reject(err);
    //         console.log("getInvoicePDF store err", err);
    //       });
    //   });
    // },

    getClients({ state, commit }, params) {
      if (state.getClientsData) return;
      return new Promise((resolve, reject) => {
        getClients()
          .then((api_data) => {
            state.getClientsData = api_data;
            resolve(api_data);
          })
          .catch((err) => {
            reject(err);
            console.log("getClients store err", err);
          });
      });
    },

    getClientById({ state, commit }, params) {
      return new Promise((resolve, reject) => {
        getClientById(params)
          .then((api_data) => {
            state.getClientByIdData = api_data;
            resolve(api_data);
          })
          .catch((err) => {
            reject(err);
            console.log("getClientById store err", err);
          });
      });
    },

    getTransactionReport({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        getTransactionReport(payload)
          .then((api_data) => {
            state.getTransactionReportData = api_data;
            resolve(api_data);
          })
          .catch((err) => {
            reject(err);
            console.log("getTransactionReport store err", err);
          });
      });
    },
  },

  mutations: {
    TOGGLE_LOADING: (state) => {
      state.Loading = !state.Loading;
    },
    SET_FILTERS: (state, { client, sDate, eDate, bill_to, email }) => {
      state.filters = {
        client_filter_selection: client,
        client_selected: client,
        start_date_filter: sDate,
        start_date_selected: sDate,
        end_date_filter: eDate,
        end_date_selected: eDate,
        bill_to: bill_to,
        email: email,
      };
    },
    SET_DATA: (state, { getTransactionReportData, getClientByIdData }) => {
      state.getTransactionReportData = getTransactionReportData;
      state.getClientByIdData = getClientByIdData;
    },
    SET_SUMMARY: (state, { clients, ratio }) => {
      if (ratio === null) return;
      if (state.data.length === 0) {
        let totalPoints = 0;

        if (clients) for (const client of clients) totalPoints += client.total;

        totalPoints = totalPoints === 0 ? totalPoints : totalPoints * -1;

        state.data = [
          {
            desc: `Divvy Points Redemption (${parseInt(totalPoints)})`,
            qty: 1,
            price: Number(((1 / ratio) * totalPoints).toFixed(2)),
            amount: Number(((1 / ratio) * totalPoints).toFixed(2)),
          },
        ];
        console.log(state.data);
      }
    },
    CLEAR_DATA: (state) => {
      state.data = [];
      state.local.pdf = null;
    },
  },
};

export default invoices;
